<footer class="main-footer">
  <div class="logo-container">
    <img src="api/config/branding/logo.png" class="logo" />
  </div>
  <div class="info branding-accent-dark-background">
    <span *ngIf="version$ | async as version" class="main-footer-version">
      {{ "Common.copyright"  | translate }} |
      {{ "Common.mqsVersion" | translate:{ value: version.memoQ } }} |
      {{ "Common.cpVersion"  | translate:{ value: version.customerPortal } }}
    </span>
  </div>
</footer>
